import { initializeApp, type FirebaseApp } from "firebase/app";

const env = import.meta.env as Record<string, string | undefined>;

/** Public web config (not secrets). Null when not configured, e.g. local dev without Firebase. */
export function getFirebaseApp(): FirebaseApp | null {
  const apiKey = env.VITE_FIREBASE_API_KEY;
  const projectId = env.VITE_FIREBASE_PROJECT_ID;
  const appId = env.VITE_FIREBASE_APP_ID;
  if (!apiKey || !projectId || !appId) return null;
  return initializeApp({
    apiKey,
    projectId,
    appId,
    authDomain: env.VITE_FIREBASE_AUTH_DOMAIN,
    messagingSenderId: env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  });
}
